import { render, staticRenderFns } from "./SpiriTual.vue?vue&type=template&id=2c8fe82a&"
import script from "./SpiriTual.vue?vue&type=script&lang=js&"
export * from "./SpiriTual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports